export const shopCategory = [
  '카페', '음식점', 'zeroWaste', '마트/할인점', '패션/주얼리', '헬스/요가', '학원/키즈', '병원/피부', '헤어/미용', '반려/관련', '관광/숙박', '시장/농가', '차량/정비', '안경/기타'
];
